import { render, staticRenderFns } from "./SmListReactions.vue?vue&type=template&id=52b7e57b&scoped=true&"
import script from "./SmListReactions.vue?vue&type=script&lang=ts&"
export * from "./SmListReactions.vue?vue&type=script&lang=ts&"
import style0 from "./SmListReactions.vue?vue&type=style&index=0&id=52b7e57b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7e57b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VChip,VIcon,VImg,VMenu})
